export const environment = {
  production: true,
  systemRibbon: ''
};
